import React from 'react';
import { IonIcon, IonModal } from '@ionic/react';
import "./LabucaModalStyle.css";
import { close } from 'ionicons/icons';

export default function LabucaModal(props) {
    const { showModal, setShowModal } = props;

    const onCloseHandler = () => setShowModal(false);

    React.useEffect(() => {
        setTimeout(() => setShowModal(true), 1200);
    }, [setShowModal]);

    return (
        <IonModal cssClass="labuca-modal" mode="md" isOpen={showModal} onDidDismiss={onCloseHandler}>
            <IonIcon className="absolute top-2 right-2 text-black" size="large" icon={close} onClick={onCloseHandler}></IonIcon>
            <img src="assets/labuca/popup.png" />
        </IonModal>
    );
}
